import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Inside /app: if the user hasn't completed onboarding, bounce them to /onboarding.
 * Invitees are marked completed server-side so they skip this.
 */
export default function OnboardingGate() {
  const { user } = useAuth();
  const location = useLocation();
  if (user && user.onboarding_completed === false) {
    if (location.pathname !== "/onboarding") {
      return <Navigate to="/onboarding" replace />;
    }
  }
  return <Outlet />;
}
